<template>
  <section>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Cuentas</h2>
    </div>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <div class="grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-8">
              <select
                class="input w-full border mt-2 flex-13"
                v-model="filter.country"
                required
              >
                <option selected :value="''">Filtrar por país</option>
                <option v-for="country in countries" :value="country.id">
                  {{ country.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Filter -->

      <div class="intro-y grid grid-cols-12 gap-2 sm:gap-3 mt-5">
        <div
          class="intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
          v-for="account in filteredAccounts"
        >
          <div
            class="file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in"
          >
            <a href="#" class="w-3/5 file__icon file__icon--directory mx-auto">
              <div class="file__icon__file-name"></div>
            </a>
            <a href="#" class="block font-medium mt-4 text-center truncate"
              >{{ account.name }} - {{ account.country.prefix }}</a
            >
            <div class="text-gray-600 text-center">{{ account.prefix }}</div>
            <div class="text-gray-600 text-center">{{ account.id }}</div>
          </div>
        </div>
      </div>
    </div>

    <app-loading v-else />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AccountsAuth',
  data() {
    return {
      filter: {
        country: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      countries: 'getAccountCountries',
    }),
    filteredAccounts: function () {
      return this.user.accounts.filter((item) => {
        if (this.filter.country === '') {
          return item
        }
        if (parseInt(this.filter.country) === item.country_id) {
          return item
        }
      })
    },
  },
  beforeMount() {
    this.loading = true
    this.getList('accountcountry').then(() => {
      this.loading = true
    })
  },
  components: {
    appLoading: Loading,
  },
  methods: {
    ...mapActions(['getList']),
  },
}
</script>



// WEBPACK FOOTER //
// AccountsAuth.vue?772d3c24